import { render, staticRenderFns } from "./ev6-fast-long.vue?vue&type=template&id=64e4aae8&scoped=true&"
import script from "./ev6-fast-long.vue?vue&type=script&lang=js&"
export * from "./ev6-fast-long.vue?vue&type=script&lang=js&"
import style0 from "./ev6-fast-long.vue?vue&type=style&index=0&id=64e4aae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4aae8",
  null
  
)

export default component.exports